import { render, staticRenderFns } from "./dict.vue?vue&type=template&id=e5fcb286&scoped=true&"
import script from "./dict.vue?vue&type=script&lang=js&"
export * from "./dict.vue?vue&type=script&lang=js&"
import style0 from "./dict.vue?vue&type=style&index=0&id=e5fcb286&prod&lang=scss&scoped=true&"
import style1 from "./dict.vue?vue&type=style&index=1&id=e5fcb286&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fcb286",
  null
  
)

export default component.exports